var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: ["gfu-filters", { "gfu-filters--collapsed": !_vm.isExpanded }],
      attrs: { "data-qa": "filters-box" },
    },
    [
      _c(
        "div",
        { attrs: { "data-qa": "filters" }, on: { click: _vm.toggle } },
        [
          _c(
            "h2",
            {
              class: [
                "gfu-filters__caption gfu-heading gfu-heading--main",
                { "gfu-filters__caption--expanded": _vm.isExpanded },
              ],
            },
            [
              _c("span", {
                class: [
                  "gfu-filters__caption-icon _fa",
                  _vm.isExpanded ? "_fa--chevron-down" : "_fa--chevron-right",
                ],
              }),
              _vm._v("Filters\n        "),
            ]
          ),
          _vm._v(" "),
          _vm.optionalFilters.length
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isExpanded,
                      expression: "isExpanded",
                    },
                  ],
                  staticClass:
                    "gfu-filters__actions gfu-filters__actions--fixed",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "gfu-filters__list",
                      attrs: { "data-qa": "filtersbox-edit-filters" },
                    },
                    [
                      _c(
                        "toggle-trigger",
                        {
                          staticClass: "gfu-link",
                          attrs: { tag: "a", href: "" },
                        },
                        [
                          _c("span", { staticClass: "_fa _fa--filter" }),
                          _vm._v(" add/remove filter"),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "toggle-container",
                        {
                          staticClass:
                            "gfu-balloon gfu-balloon--right gfu-balloon--no-header gfu-table__dropdown is-hidden",
                          attrs: {
                            tag: "div",
                            tabindex: "0",
                            "active-class": "is-open",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "gfu-balloon__content",
                              attrs: {
                                "data-qa":
                                  "filtersbox-filters-selection-balloon",
                              },
                            },
                            _vm._l(
                              _vm.optionalFilters,
                              function (filter, index) {
                                return _c(
                                  "div",
                                  {
                                    key: `filter-${index}`,
                                    staticClass: "gfu-balloon__item",
                                  },
                                  [
                                    _c(
                                      "checkbox-field",
                                      {
                                        class: { "_mt-0": index === 0 },
                                        attrs: {
                                          condensed: true,
                                          "data-qa": `filters-list-checkbox:${filter.componentInstance.displayName}`,
                                        },
                                        model: {
                                          value:
                                            filter.componentInstance.isVisible,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              filter.componentInstance,
                                              "isVisible",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "filter.componentInstance.isVisible",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            filter.componentInstance.displayName
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isExpanded,
              expression: "isExpanded",
            },
          ],
          staticClass: "gfu-filters__body",
        },
        [
          _c(
            "div",
            { staticClass: "gfu-grid gfu-grid--gutter-columns" },
            [_vm._t("default")],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isExpanded,
              expression: "isExpanded",
            },
          ],
          staticClass: "gfu-filters__actions",
        },
        [
          _c(
            "a",
            {
              staticClass: "gfu-link gfu-filters__reset",
              attrs: {
                href: "",
                "data-qa": "filtersbox-filters-selection-reset",
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.reset.apply(null, arguments)
                },
              },
            },
            [_c("span", { staticClass: "_fa _fa--undo" }), _vm._v(" reset")]
          ),
          _vm._v(" "),
          _c(
            "icon-base-button",
            {
              attrs: {
                icon: "filter",
                theme: "accent",
                enabled: _vm.hasChanges,
                "data-qa": "filtersbox-filters-selection-apply",
              },
              on: { click: _vm.onApplyFilters },
            },
            [_vm._v("apply filter")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }